import { of } from "rxjs";
import { catchError, filter, ignoreElements, map, mergeMap, tap } from "rxjs/operators";

import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../redux/action.functions";
import * as navigationService from "../../../features/navigation/services/navigation.service";

import * as executionBriefService from "../services/execution-brief.service";

import * as actions from "./execution-brief.actions";
import { ExecutionBriefActions } from "./execution-brief.actions";
import { ExecutionBriefWorkOrdersEffects } from "./execution-brief-work-orders/execution-brief-work-orders.effects";

const duplicate: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(ExecutionBriefActions.Duplicate)),
    map((action) => action.payload),
    mergeMap((form) =>
      executionBriefService.duplicate(form).pipe(
        map((result) => actions.duplicateSuccess(result)),
        catchError((error) => of(actions.duplicateFailure(error)))
      )
    )
  );

const newBriefRedirect: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(ExecutionBriefActions.DuplicateSuccess)),
    map((action) => action.payload),
    tap((brief) => navigationService.goToExecutionBrief(brief.id)),
    ignoreElements()
  );

export const ExecutionBriefEffects = [
  duplicate,
  newBriefRedirect,
  ...ExecutionBriefWorkOrdersEffects,
];
